import { RamlServicesMealPassengerAppliedMeal } from '@common/interfaces';
import { CurrentCartState } from '@common/store';
import { TestData_PASSENGER as PASS } from '../passenger-test-data';
import { TestData_BOUND as BOUND } from '../bound-test-data';

export function getMealTestData(data: CurrentCartState): any {
  if (!data.data?.plan?.services) {
    return data;
  }
  data.data.cartId = 'CART_ID001';
  data.data.plan.services.meal = {};
  data.data.plan.services.meal['ID001'] = { isAvailable: true, isExpired: false };
  data.data.plan.services.meal['ID002'] = { isAvailable: true, isExpired: false };
  data.data.plan.services.meal['ID004'] = { isAvailable: true, isExpired: false };
  data.data.plan.services.meal['ID005'] = { isAvailable: true, isExpired: false };
  data.data.plan.services.meal['ID006'] = { isAvailable: true, isExpired: false };
  data.data.plan.services.meal['ID001'].isAvailable = true;
  data.data.plan.services.meal['ID001']['PASSENGER00101'] = { appliedMealList: [appliedMeal1] };
  data.data.plan.services.meal['ID001']['PASSENGER00102'] = { appliedMealList: [appliedMeal1] };
  data.data.plan.services.meal['ID001']['PASSENGER00201'] = { appliedMealList: [appliedMeal3] };
  data.data.plan.services.meal['ID002']['PASSENGER00101'] = { appliedMealList: [appliedMeal1] };

  data.data.plan.services.meal['ID004']['TRAVELER_R01_M51_1'] = { appliedMealList: [MEAL_R01_M51_1_1] };
  data.data.plan.services.meal['ID005']['TRAVELER_R01_M51_1'] = { appliedMealList: [MEAL_R01_M51_1_2] };
  data.data.plan.services.meal['ID006']['TRAVELER_R01_M51_1'] = { appliedMealList: [MEAL_R01_M51_1_3] };
  data.data.plan.services.meal['ID005']['TRAVELER_R01_M51_2'] = { appliedMealList: [MEAL_R01_M51_2_1] };
  data.data.plan.services.meal['ID006']['TRAVELER_R01_M51_2'] = { appliedMealList: [MEAL_R01_M51_2_2] };
  data.data.plan.services.meal['ID006']['TRAVELER_R01_M51_3'] = { appliedMealList: [MEAL_R01_M51_3] };
  data.data.plan.services.meal['ID006']['TRAVELER_R01_M51_4'] = { appliedMealList: [MEAL_R01_M51_4] };
  data.data.plan.services.meal['ID006']['TRAVELER_R01_M51_5'] = { appliedMealList: [MEAL_R01_M51_5] };
  data.data.plan.services.meal['ID006']['TRAVELER_R01_M51_6'] = { appliedMealList: [MEAL_R01_M51_6] };
  data.data.plan.services.meal['ID006']['TRAVELER_R01_M51_7'] = { appliedMealList: [MEAL_R01_M51_7] };
  data.data.plan.services.meal['ID006']['TRAVELER_R01_M51_8'] = { appliedMealList: [MEAL_R01_M51_8] };
  if (data.data?.plan?.airOffer?.bounds) {
    data.data.plan.airOffer.bounds = [BOUND.bound2, BOUND.bound3];
  }
  if (data.data?.plan?.travelers) {
    data.data.plan.travelers = [
      PASS.TRAVELER1,
      PASS.TRAVELER2,
      PASS.TRAVELER3,
      PASS.TRAVELER_R01_M51_1,
      PASS.TRAVELER_R01_M51_2,
      PASS.TRAVELER_R01_M51_3,
      PASS.TRAVELER_R01_M51_4,
      PASS.TRAVELER_R01_M51_5,
      PASS.TRAVELER_R01_M51_6,
      PASS.TRAVELER_R01_M51_7,
      PASS.TRAVELER_R01_M51_8,
    ];
  }
  return data;
}

const DEFAULT_MEAL: RamlServicesMealPassengerAppliedMeal = {
  code: '',
  id: 'SERVICE1',
  statusCode: 'SSR01',
  type: '', //ancillary-special-preOrder
  preOrderMealMessageId: '',
  serviceStatus: '', //-confirmed-prebooked‐confirmedWithoutTsm-requesting-cancelled-requested
  price: {
    total: 1110,
    currencyCode: 'JPY',
  },
};

const appliedMeal1: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  code: 'CAML',
  type: 'ancillary', //ancillary-special-preOrder
  serviceStatus: 'requested', //-confirmed-prebooked‐confirmedWithoutTsm-requesting-cancelled-requested
};

const appliedMeal2: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  code: 'CAML',
  id: 'SERVICE2',
  statusCode: 'SSR02',
  type: 'special', //ancillary-special-preOrder
  serviceStatus: 'requested', //-confirmed-prebooked‐confirmedWithoutTsm-requesting-cancelled-requested
  price: {
    total: 2450,
    currencyCode: 'JPY',
  },
};

const appliedMeal3: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  code: 'BBML',
  id: 'SERVICE3',
  statusCode: 'SSR03',
  type: 'special', //ancillary-special-preOrder
  preOrderMealMessageId: '',
  serviceStatus: 'requested', //-confirmed-prebooked‐confirmedWithoutTsm-requesting-cancelled-requested
  price: {
    total: 2450,
    currencyCode: 'JPY',
  },
};

const MEAL_R01_M51_1_1: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  code: 'CAML',
  type: 'ancillary',
  serviceStatus: 'requested',
  id: 'SSR001',
  price: {
    total: 5200,
    currencyCode: 'JPY',
  },
};
const MEAL_R01_M51_1_2: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  code: 'PRE0003',
  type: 'preOrder',
  preOrderMealMessageId: 'label.preorder.ofml.western',
  serviceStatus: 'requested',
  id: 'SSR001',
  price: {
    total: 0,
    currencyCode: 'JPY',
  },
};
const MEAL_R01_M51_1_3: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  code: 'BLML',
  type: 'special',
  serviceStatus: 'requested',
  id: 'SSR001',
  price: {
    total: 99999999,
    currencyCode: 'JPY',
  },
};
const MEAL_R01_M51_2_1: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  id: 'SSR002',
};
const MEAL_R01_M51_2_2: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  code: 'PRE0003',
  type: 'preOrder',
  preOrderMealMessageId: '',
  serviceStatus: 'requested',
  id: 'SSR001',
  price: {
    total: 0,
    currencyCode: 'JPY',
  },
};
const MEAL_R01_M51_3: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  id: 'SSR003',
};
const MEAL_R01_M51_4: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  id: 'SSR004',
};
const MEAL_R01_M51_5: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  id: 'SSR005',
};
const MEAL_R01_M51_6: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  id: 'SSR006',
};
const MEAL_R01_M51_7: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  id: 'SSR007',
};
const MEAL_R01_M51_8: RamlServicesMealPassengerAppliedMeal = {
  ...DEFAULT_MEAL,
  id: 'SSR008',
};
